import {Component, OnDestroy, OnInit} from '@angular/core';
import {FormArray, FormBuilder} from '@angular/forms';
import {ProjectUtilsService} from '../../services/project-utils.service';
import {Flow} from '@app/shared';
import {FlowEventService, ScreenService} from '@app/core';
import {NzDrawerService} from 'ng-zorro-antd/drawer';
import {combineLatest, take} from 'rxjs';
import {EditFlowDrawerComponent} from '../../drawers/edit-flow-drawer/edit-flow-drawer.component';
import {GlobalValuesService} from '../../../../core/services/global-values.service';
import {AuthService} from '../../../../core/services/auth.service';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-flow-section',
  standalone: false,

  templateUrl: './flow-section.component.html',
  styleUrl: './flow-section.component.less'
})
export class FlowSectionComponent implements OnInit, OnDestroy {

  eventTypes: FormArray | undefined;

  editFlowDrawer: any;

  constructor(private fb: FormBuilder,
              public ps: ProjectUtilsService,
              public gs: GlobalValuesService,
              private flowEventService: FlowEventService,
              private drawerService: NzDrawerService,
              public screenService: ScreenService,
              public authService: AuthService,
  ) {
    this.ps.closeAllDrawers$.pipe(takeUntilDestroyed()).subscribe(value => {
      if (value) {
        this.editFlowDrawer?.close();
      }
    })
  }

  ngOnInit() {
    this.eventTypes = this.fb.array([]);

    if (this.ps.selectedService?.flow) this.gs.setEventFlow([this.ps.selectedService.flow]);

    if (this.ps.selectedService && this.ps.selectedService?.flow) {
      this.setEvents(this.ps.selectedService.flow);
    }
  }

  setEvents(flow: Flow) {
    this.flowEventService.setEvents(flow, this.eventTypes as FormArray, this.fb);
  }

  openCreateServiceDrawer(): void {
    combineLatest({
      isMobile: this.screenService.isMobile$,
      isMedium: this.screenService.isMedium$,
    }).pipe(take(1)).subscribe(({isMobile, isMedium}) => {
      this.editFlowDrawer = this.drawerService.create({
        nzWidth: 793,
        nzHeight: '98%',
        nzPlacement: isMobile ? 'bottom' : 'right',
        nzClosable: false,
        nzMask: true,
        nzMaskClosable: false,
        nzContent: EditFlowDrawerComponent,
        nzData: {
          events: this.eventTypes,
          originalFlow: this.ps.selectedService!.flow
        }
      });

      this.editFlowDrawer.afterOpen.pipe(take(1)).subscribe(() => {
        this.editFlowDrawer.getContentComponent().newEvents.pipe(take(1)).subscribe((value: any) => {
          // El selectedService ya fue actualizado en el edit-flow-drawer
          // Solo necesitamos actualizar el FormArray local
          this.setEvents(this.ps.selectedService!.flow!);
        })
      })
    });
  }

  ngOnDestroy() {
    this.editFlowDrawer?.close();
  }

}
